import { MoreVertical } from "lucide-react";
import DropdownMenu, {
  DropdownMenuItem,
} from "@/components/menus/DropdownMenu";

export type KebabMenuItem = DropdownMenuItem;

interface KebabMenuProps {
  items: KebabMenuItem[];
}

const KebabMenu: React.FC<KebabMenuProps> = ({ items }) => (
  <DropdownMenu
    items={items}
    renderTrigger={({ ref, props }) => (
      <button
        ref={ref}
        {...props}
        className="flex h-10 w-10 items-center justify-center rounded-lg text-cream-700 hover:bg-cream-200 dark:text-cream-300 dark:hover:bg-cream-800"
        aria-label="More actions"
        type="button"
      >
        <MoreVertical size={20} />
      </button>
    )}
  />
);

export default KebabMenu;
